import { Form, Input } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { IoIosSend, IoMdSend } from "react-icons/io";
import { sendMessage, listenForMessages } from "../../../Services/chatService";
import dayjs from "dayjs";

function PatientChat({ selectedChat }) {
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const inputRef = useRef();
  const chatContainerRef = useRef(null);

  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  useEffect(() => {
    if (selectedChat) {
      listenForMessages(
        loginResultObject.user.userId,
        selectedChat.patientId,
        setMessages
      );
    }
  }, []);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const handleSend = async () => {
    if (message.trim()) {
      try {
        await sendMessage(
          loginResultObject.user.userId,
          selectedChat.patientId,
          message
        );
        listenForMessages(
          selectedChat.patientId,
          loginResultObject.user.userId,
          setMessages
        );
        inputRef?.current?.resetFields();
        setMessage("");
      } catch (error) {
        console.error("Error sending message:", error);
      }
    }
  };

  const handleMsgSend = (event) => {
    if (event.key === "Enter") {
      handleSend();
    }
  };

  return (
    <div>
      <div className="w-full chatCustomHeight bg-white relative">
        <div ref={chatContainerRef} className="h-[85%] hideScrollBar px-2">
          {messages &&
            messages
              ?.sort(
                (a, b) => a.timestamp?.toMillis() - b.timestamp?.toMillis()
              )
              .map((msg) => (
                <div className="w-full flex items-center justify-between">
                  {msg.senderID !== selectedChat.patientId ? (
                    <div
                      key={msg.id}
                      className="max-w-64 my-0.5 relative p-1 text-slate-800 bg-[#c0e9e9] border rounded-l-lg rounded-br-lg ml-auto"
                    >
                      {msg.text}
                      <div className="flex justify-end">
                        <span className="text-[8px]">
                          {dayjs(msg.timestamp?.toDate()).format("hh:mm A")}
                        </span>
                      </div>
                      <svg
                        className="absolute top-0 right-0 translate-x-2 translate-y-0"
                        width="8"
                        height="13"
                        viewBox="0 0 8 13"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <path
                          opacity="0.13"
                          fill="#000000"
                          d="M6.467,3.568L0,12.193V1h5.188C6.958,1,7.526,2.156,6.467,3.568z"
                        ></path>
                        <path
                          fill="#c0e9e9"
                          d="M6.467,2.568L0,11.193V0h5.188C6.958,0,7.526,1.156,6.467,2.568z"
                        ></path>
                      </svg>
                    </div>
                  ) : (
                    <div
                      key={msg.id}
                      className="max-w-64 my-0.5 relative p-1 text-slate-800 bg-[#e5e2e2] border rounded-r-lg rounded-bl-lg mr-auto"
                    >
                      {msg.text}
                      <div className="flex justify-end">
                        <span className="text-[8px]">
                          {dayjs(msg.timestamp?.toDate()).format("hh:mm A")}
                        </span>
                      </div>
                      <svg
                        className="absolute top-0 left-0 -translate-x-2 translate-y-0"
                        width="8"
                        height="13"
                        viewBox="0 0 8 13"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <path
                          opacity="0.13"
                          fill="#000000"
                          d="M1.533,3.568L8,12.193V1H2.812 C1.042,1,0.474,2.156,1.533,3.568z"
                        ></path>
                        <path
                          fill="#e5e2e2"
                          d="M1.533,2.568L8,11.193V0L2.812,0C1.042,0,0.474,1.156,1.533,2.568z"
                        ></path>
                      </svg>
                    </div>
                  )}
                </div>
              ))}
        </div>
        <div className="w-full flex items-center gap-2 p-2">
          <div className="w-[90%]">
            <input
              type="text"
              className="border rounded-3xl outline-none w-full py-2 text-xs px-2 font-medium"
              placeholder="Type message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={handleMsgSend}
            />
          </div>
          <div className="w-[10%]">
            <div
              onClick={handleSend}
              className="w-7 h-7 rounded-full bg-brand-primaryColor flex items-center justify-center cursor-pointer"
            >
              <IoMdSend className="w-5 h-5 text-white" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PatientChat;
